import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { ContactScreenComponent } from './contact-screen.component';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TamDashboardModule } from '../tam-dashboard/tam-dashboard.module';
import { ResearchComponentModule } from '../research-component.module';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { CalendarScreenModule } from '../calendar-screen/calendar-screen.module';
import { ContactDetailModule } from '../contact-panel/contact-detail.module';
import { ContactDetailTemplateModule } from '../contact-detail-new/contact-detail-template/contact-detail-template.module';
import { ContactDetailNewModule } from '../contact-detail-new/contact-detail-new.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        TooltipModule,
        TamDashboardModule,
        ResearchComponentModule,
        TreeViewModule,
        CalendarScreenModule,
        ContactDetailModule,
        ContactDetailTemplateModule,
        ContactDetailNewModule
    ],
    declarations: [
        ContactScreenComponent,
    ],
    exports: [
        ContactScreenComponent,
    ],
    providers: []
})
export class ContactScreenModule {

}
